import {createSelector} from "reselect";
import { getPartnerParams } from "../partnerSelectors";

export const getPartnerPostbackTypesSelector = createSelector(
    getPartnerParams, state => state.postbacks_types || []
);

export const getPartnerPostbackUrlTokensSelector = createSelector(
    getPartnerParams, state => state.postbacks_url_tokens || []
);
